/* FILE: ./frontend/src/features/canada/pages/SupplierAnalytics.jsx */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // ⚡ ADDED

// ⚡ ADDED useNavigate

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1';

export default function SupplierAnalytics() {
  const { t } = useTranslation(); // ⚡ ADDED
  const { user, supplierId, userProfile } = useAuth();
  const navigate = useNavigate(); // ⚡ INITIALIZED
  const [data, setData] = useState({ metrics: { totalViews: 0 }, recentVisitors: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // ⚡ MODULAR PAYWALL FIX: Unlocked by the Analytics Module (or Admin)
  const hasAccess = userProfile?.has_analytics ||
  userProfile?.role === 'admin';

  useEffect(() => {
    const fetchAnalytics = async () => {
      if (!user || !supplierId) return;
      try {
        const response = await axios.get(`${API_BASE}/analytics/dashboard/${supplierId}`, {
          headers: { 'x-user-id': user.id }
        });
        setData(response.data);
      } catch (err) {
        setError('Failed to load analytics data.');
    
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [user, supplierId]);
  if (loading) {
    return <div className="p-12 text-center text-gray-500 animate-pulse font-bold">{t('analytics.loading')}</div>;
  }

  if (error) {
    return <div className="p-6 m-8 bg-red-50 text-red-700 rounded-xl border border-red-200 font-bold text-center">{error}</div>;
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 font-sans">
      
      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
        <div>
           <h1 className="text-2xl font-bold text-gray-900 tracking-tight">{t('analytics.title')}</h1>
           <p className="text-sm text-gray-500 mt-1">{t('analytics.subtitle')}</p>
        </div>
      
        {!hasAccess && (
            <button
                onClick={() => navigate('/billing?modules=analytics')} // ⚡ REAL REDIRECTION
                className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-yellow-950 px-6 py-2.5 rounded-lg font-bold shadow-md hover:shadow-lg transition-all flex items-center gap-2"
            >
                <span>{t('analytics.upgrade_btn')}</span>
            </button>
        )}
      </div>

      {/* MACRO STATS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col justify-center items-center text-center">
              <span className="text-gray-400 font-bold text-xs uppercase tracking-wider mb-2">{t('analytics.total_views')}</span>
         
              <span className="text-5xl font-black text-blue-600">{data.metrics.totalViews ||
0}</span>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col justify-center items-center text-center relative overflow-hidden">
              <span className="text-gray-400 font-bold text-xs uppercase tracking-wider mb-2">{t('analytics.search_app')}</span>
              <span className={`text-5xl font-black ${hasAccess ?
'text-gray-800' : 'text-gray-300 blur-sm'}`}>
                  {hasAccess ?
(data.metrics.totalViews * 3) : '842'} 
              </span>
              {!hasAccess && <span className="absolute inset-0 flex items-center justify-center font-bold text-xs bg-white/50 text-gray-600 uppercase tracking-widest">{t('analytics.premium_only')}</span>}
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col justify-center items-center text-center relative overflow-hidden">
              <span className="text-gray-400 font-bold text-xs uppercase tracking-wider 
mb-2">{t('analytics.eng_rate')}</span>
              <span className={`text-5xl font-black ${hasAccess ?
'text-green-500' : 'text-gray-300 blur-sm'}`}>
                  {hasAccess ?
'12.4%' : '15%'}
              </span>
              {!hasAccess && <span className="absolute inset-0 flex items-center justify-center font-bold text-xs bg-white/50 text-gray-600 uppercase tracking-widest">{t('analytics.premium_only')}</span>}
          </div>
      </div>

      {/* RECENT VISITORS THE HOOK */}
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden relative">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 
flex justify-between items-center">
              <h3 className="font-bold text-gray-800">{t('analytics.recent_views')}</h3>
              {hasAccess ?
(
                  <span className="text-xs font-bold text-green-600 bg-green-100 px-3 py-1 rounded-full">{t('analytics.live_data')}</span>
              ) : (
                  <span className="text-xs font-bold text-yellow-800 bg-yellow-100 px-3 py-1 rounded-full">{t('analytics.masked_data')}</span>
              )}
          </div>

       
          {data.recentVisitors.length === 0 ? (
              <div className="p-12 text-center text-gray-500">
                  <span className="text-4xl mb-3 block">👀</span>
                  <p>{t('analytics.no_views')}</p>
              </div>
         
          ) : (
              <div className="divide-y divide-gray-100">
                  {data.recentVisitors.map((visitor, idx) => (
                      <div key={idx} className="p-5 flex items-center justify-between transition-colors hover:bg-gray-50">
                          <div className="flex items-center gap-4">
  
                             <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-500 font-bold">
                                  {visitor.isMasked ? '🔒' : visitor.name.charAt(0)}
                         
                              </div>
                              <div>
                                  <p className={`font-bold text-gray-900 ${visitor.isMasked ? 'blur-[4px] select-none opacity-60' : ''}`}>
                      
                                {visitor.isMasked ?
t('analytics.major_firm') : visitor.name}
                                  </p>
                                  <p className="text-xs text-gray-500 mt-0.5">
                        
                              📍 {visitor.isMasked ?
t('analytics.canada') : visitor.location} • {new Date(visitor.date).toLocaleDateString()}
                                  </p>
                              </div>
                          </div>
     
                      <div>
                              {visitor.isMasked ?
(
                                  <button 
                                    onClick={() => navigate('/billing?modules=analytics')} // ⚡ REAL REDIRECTION
                      
                                    className="text-xs font-bold bg-gray-900 text-white px-4 py-2 rounded shadow-sm hover:bg-gray-800 transition-colors"
                                  >
                                      {t('analytics.reveal_buyer')}
    
                                  </button>
                              ) : (
                                  <span className="text-xs font-bold text-blue-600 
border border-blue-200 bg-blue-50 px-3 py-1 rounded">
                                      {t('analytics.active_prospect')}
                                  </span>
                      
                )}
                          </div>
                      </div>
                  ))}
              </div>
          )}

  
         {/* ⚡ THE PAYWALL OVERLAY FOR FREE USERS */}
          {!hasAccess && data.recentVisitors.length > 0 && (
              <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-white via-white/90 to-transparent flex flex-col items-center justify-end pb-8">
                  <p className="font-bold text-gray-900 mb-3 drop-shadow-md">{t('analytics.stop_guessing')}</p>
           
                  <button 
                    onClick={() => navigate('/billing?modules=analytics')} // ⚡ REAL REDIRECTION
                    className="bg-yellow-500 hover:bg-yellow-400 text-yellow-950 px-8 py-3 rounded-xl font-black shadow-xl transition-transform transform hover:-translate-y-1"
                  >
                 
                    {t('analytics.unlock_identities')}
                  </button>
              </div>
          )}
      </div>

    </div>
  );
}